export const language: any = {
  selected_ingredients: '選択した食材',
  recommend: 'おすすめの料理',
  title_detail: 'おすすめレシピ',
  share: 'シェア',
  ingredients: {
    title: `<span class="tracking-tighter whitespace-nowrap">食材</span> <span class="tracking-tighter whitespace-nowrap">(1人前)</span>`,
    add_all: 'すべての食材を追加',
    view_more: '{number} 種類の食材をもっと見る',
    view_less: '折りたたむ',
    delete_all: 'すべての食材を削除',
  },
  how_to_cook: '調理方法',
  video: {
    title: '動画レシピ',
  },
  msg: {
    msg_1: "この食材を削除してもよろしいですか？",
    msg_2: "すべての食材を削除してもよろしいですか？",
    msg_3: "この食材を追加しますか？",
    msg_4: "不足しているすべての食材を追加しますか？",
    msg_5: "選択した食材をショッピングカートに追加しますか？",
    msg_6: "この食材はすでにショッピングカートに入っています。",
    confirm: "はい",
    cancel: "いいえ",
  },
  recipe_exist_in_cart: "この食材はすでにショッピングカートに入っています。",
  recipe_want_add_to_cart: "選択した食材をショッピングカートに追加しますか？",
  recipe_exist_in_cart_should_exclued: "は現在のカートに既に入っているため、除外されました。",
  calories_description: "この料理は、以下のレシピに基づいて約 {calories} カロリーを含むと推定されています。健康のために適切な選択を考慮してください！",
  title_share_sns: "このレシピを共有する",
  copy: "コピー",
  recipe_add_cart_success: "カートに追加されました。カート画面に移動しますか？",
  recipe_close: "閉じる",
  recipe_move: "移動",
  recipe_add_ingredient_success: "選択した材料が追加されました。材料画面に移動しますか？",
  copied: "コピーしました",
  text_share_sns: `{recipe_name} このレシピはいかがですか？\nHey! Cookerでチェックしてみてください！`,
  search: {
    title: "レシピを検索",
    searching: "Hey Cooker はあなたのキーワードに合ったレシピを<br/>検索中です。少々お待ちください！",
    not_found: "Hmm、AIシェフはあなたのキーワードに合った料理を<br/>見つけられませんでした。別の料理名を入力してください。",
    placeholder: "検索したいレシピ名を入力してください...",
    msg_default_recipe: "まだレシピがありません",
  },
  noData: "結果が見つかりません",
  searching: "検索中..."
}
